// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rounded-none';

export const Component = () => (
  <g fill='none' stroke='transparent' strokeLinecap='round' strokeLinejoin='round'>
    <path fill='#D0E0F7' d='M1 1h18v18H1V1Z' />
    <path fill='#4185DE' d='M1 1V0H0v1h1Zm0 1h18V0H1v2Zm1 17V1H0v18h2Z' />
  </g>
);

export const viewBox = '0 0 18 18';
